module.exports = __webpack_public_path__ + "static/img/2786_phase_function_Paper_PointsHejduk_Prediction.44ce95b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2786_phase_function_Paper_PointsHejduk_Prediction.png
// module id = /qzO
// module chunks = 0